"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-09a6d7a0"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = ["id"];
const vue_3 = require("vue");
const SlotBadges_vue_1 = __importDefault(require("../../../vue/components/SlotBadges.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SpotWorkerSlot',
    props: {
        shift: {}
    },
    emits: ["selected-shift"],
    setup(__props, { emit: __emit }) {
        const roleStore = (0, vue_3.inject)("roleStore");
        const props = __props;
        const emits = __emit;
        function handleSlotClick() {
            emits("selected-shift", props.shift.id);
        }
        const computeChipStyle = (0, vue_3.computed)(() => {
            const bg = roleStore?.byId(props.shift.roleId.toString())?.color;
            return {
                backgroundColor: bg ? `#${bg}` : "",
                color: bg ? "#fff" : "",
            };
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `vue-slot-${_ctx.shift.id}`
            }, [
                (0, vue_2.createElementVNode)("div", {
                    class: "chip vue-chip slot spot-shift-slot",
                    style: (0, vue_2.normalizeStyle)(computeChipStyle.value),
                    onClick: handleSlotClick,
                    id: `slot-${_ctx.shift.id}`
                }, [
                    (0, vue_2.createVNode)(SlotBadges_vue_1.default, {
                        "spot-work-ask": !_ctx.shift.userId ? 1 : 0
                    }, null, 8 /* PROPS */, ["spot-work-ask"]),
                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.shift.purpose) + " " + (0, vue_2.toDisplayString)(_ctx.shift.timeLabel), 1 /* TEXT */)
                ], 12 /* STYLE, PROPS */, _hoisted_2)
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
